/** Axis tick generation: 1-2-5 for linear scales, decades for log scales. */

export function linTicks(lo: number, hi: number, target = 6): number[] {
  if (!(hi > lo)) return [lo];
  const span = hi - lo;
  const step0 = span / target;
  const mag = 10 ** Math.floor(Math.log10(step0));
  const step = [1, 2, 5, 10].map((m) => m * mag).find((s) => span / s <= target) ?? 10 * mag;
  const ticks: number[] = [];
  for (let t = Math.ceil(lo / step) * step; t <= hi + step * 1e-9; t += step) ticks.push(t);
  return ticks;
}

/** Decade ticks between lo and hi (both > 0). */
export function logTicks(lo: number, hi: number): number[] {
  const ticks: number[] = [];
  for (let e = Math.ceil(Math.log10(lo) - 1e-9); 10 ** e <= hi * (1 + 1e-9); e++) ticks.push(10 ** e);
  return ticks;
}
